import { CircularProgress } from '@mui/joy'
import Layout from '../Layout'

const Loading = () => {
	return (
		<Layout>
			<div
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					height: "100%"
				}}
			>
				<CircularProgress />
			</div>
		</Layout>
	)
}

export default Loading